<template>
  <div>
    <Loading v-if="!loadStatus" text="Loading..." />
    <template v-if="loadStatus">
      <div class="flex items-center search-region">
        <div class="search-holder">
          <Search
            placeholder="search by name"
            @input="value => (searchQuery = value)"
          />
        </div>
      </div>

      <div v-if="projectsList.length">
        <vue-good-table
          :columns="projectColumns"
          :rows="resultQuery"
          styleClass="vgt-table striped"
          :pagination-options="{
            enabled: false,
            mode: 'records',
            perPage: 50,
            perPageDropdown: [10, 15, 20],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All'
          }"
        >
          <template slot="table-row" slot-scope="projectsList">
            <div v-if="projectsList.column.field === 'inHandsDate'">
              {{
                projectsList.row.inHandsDate
                  ? defaultFormatAndParse(projectsList.row.inHandsDate)
                  : 'N/A'
              }}
            </div>
            <span v-else-if="projectsList.column.field === 'detailsUrl'">
              <router-link
                :to="{
                  name: 'ProjectDetail',
                  params: { id: projectsList.row.id }
                }"
                class="hoverable-text font-bold inter"
                >View Details</router-link
              >
            </span>

            <span v-else-if="projectsList.column.field === 'state'">
              {{ formatState(projectsList.row.state) }}
            </span>
          </template>
        </vue-good-table>
      </div>
      <div v-else>
        <ProjectsListZeroState />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DateFns from '@/mixins/DateFns'
import { progressStatus } from '../../helpers'
import { VueGoodTable } from 'vue-good-table'
import Search from '@/components/Universal/Search.vue'

export default {
  name: 'ProjectsList',
  mixins: [DateFns],
  components: {
    VueGoodTable,
    Search,
    ProjectsListZeroState: () =>
      import('@/components/Projects/ProjectsListZeroState')
  },
  created() {
    this.$store.dispatch('project/getProjectsList')
  },
  data() {
    return {
      searchQuery: '',
      projectColumns: [
        {
          label: 'Name',
          field: 'name',
          width: '25%'
        },
        {
          label: 'Fulfillment date',
          field: 'inHandsDate',
          width: '20%'
        },
        {
          label: 'Status',
          field: 'state',
          width: '15%',
          tdClass: 'td-center'
        },
        {
          label: 'Submissions',
          field: 'submissions',
          width: '5%',
          tdClass: 'td-left'
        },
        {
          label: 'Account manager',
          field: 'manager',
          width: '25%'
        },
        {
          label: 'Details',
          field: 'detailsUrl',
          sortable: false,
          width: '15%'
        }
      ]
    }
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.projectsList.filter(list => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(v => list.name.toLowerCase().includes(v))
        })
      } else {
        return this.projectsList
      }
    },

    loadStatus() {
      return progressStatus(this.projectsListLoading)
    },
    ...mapState({
      projectsListLoading: state => state.project.projectsListLoading,
      projectsList: state => state.project.projectsList
    })
  },

  methods: {
    formatState(state) {
      return state
        .replace('_', ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.search-region {
  margin-top: 4rem;
  margin-bottom: 2rem;
  .search-holder {
    width: 60%;
  }
}
@media (max-width: 860px) {
  .search-holder {
    width: 100% !important;
  }
}
</style>
